/**
 *  @class
 *  @function FeaturedProductCard
 */

if (!customElements.get('featured-product-card')) {
  class FeaturedProductCard extends HTMLElement {
    constructor() {
      super();

      this.tl = false;
      this.splittext = false;
      this.splide = null;
    }
    
    connectedCallback() {
      this.initCarousel();
      
      if (document.body.classList.contains('animations-true') && typeof gsap !== 'undefined') {
        this.prepareAnimations();
      }
    }
    
    disconnectedCallback() {
      if (document.body.classList.contains('animations-true') && typeof gsap !== 'undefined') {
        if (this.tl) this.tl.kill();
        if (this.splittext) this.splittext.revert();
      }
      
      if (this.splide) {
        this.splide.destroy();
      }
    }
    
    initCarousel() {
  const carousel = this.closest('.featured-product-carousel');
  if (!carousel || typeof Splide === 'undefined') return;

  const section = carousel.closest('[data-section-type], .section-featured-product-card');
  const autoplay = section?.dataset.autoplay === 'true';
  const autoplayInterval = parseInt(section?.dataset.autoplayInterval) || 5000;
  const pauseOnHover = section?.dataset.pauseOnHover !== 'false';

  // ✅ Enable drag and swipe
  this.splide = new Splide(carousel, {
    type: 'fade',
    rewind: true,
    pagination: false,
    arrows: true, // ❌ remove arrows
    autoplay: autoplay,
    interval: autoplayInterval,
    pauseOnHover: pauseOnHover,
    pauseOnFocus: true,
    resetProgress: true,
    speed: 800,
    easing: 'cubic-bezier(0.25, 0.46, 0.45, 0.94)',
    drag: true, // ✅ allow mouse/touch dragging
    swipe: true, // ✅ enable touch swiping
    keyboard: true, // optional: allow arrow key navigation
    accessibility: {
      autoplay: true,
      pauseOnHover: pauseOnHover,
      pauseOnFocus: true,
    },
  });

  this.setupProgressBar();
  this.splide.mount();
}

    
    setupProgressBar() {
      if (!this.splide) return;
      
        const carouselRoot = this.closest('.splide'); 
        const desktopProgress = carouselRoot?.querySelector('.desktop-progress .splide__progress__bar');
        const mobileProgress  = carouselRoot?.querySelector('.mobile-progress .splide__progress__bar');
      let progressInterval;
      
       const updateProgress = (index) => {
    const totalSlides = this.splide.Components.Slides.getLength(); // ✅ correct total slides
    const progress = ((index + 1) / totalSlides) * 100;

    // console.warn("totalSlides", totalSlides);
    // console.warn("currentIndex", index);
    // console.warn("progress", progress);

    if (desktopProgress) desktopProgress.style.width = `${progress}%`;
    if (mobileProgress) mobileProgress.style.width = `${progress}%`;
  };

  const boundUpdateProgress = updateProgress.bind(this);
   // Run once on mount
  this.splide.on("mounted", () => {
    updateProgress(this.splide.index);
  });

  // Update only after slide movement finishes
  this.splide.on("moved", (newIndex) => {
    updateProgress(newIndex);
  });
      
      const startProgress = () => {
        const interval = this.splide.options.interval;
        const startTime = Date.now();
        
        progressInterval = setInterval(() => {
          const elapsed = Date.now() - startTime;
          const progress = Math.min((elapsed / interval) * 100, 100);
          updateProgress(progress);
          
          if (progress >= 100) {
            clearInterval(progressInterval);
          }
        }, 50);
      };
      
      const resetProgress = () => {
        clearInterval(progressInterval);
        updateProgress(0);
      };
      
      
      // this.splide.on('autoplay:playing', startProgress);
      // this.splide.on('autoplay:paused', () => clearInterval(progressInterval));
      // this.splide.on('move', resetProgress);
      // this.splide.on('moved', () => {
      //   if (this.splide.Components.Autoplay.isPaused()) return;
      //   setTimeout(startProgress, 100);
      // });
      
      // this.splide.on('click', resetProgress);
      
      // if (this.splide.options.autoplay) {
      //   setTimeout(startProgress, 100);
      // }
    }
    
    prepareAnimations() {
      let section = this,
        button_offset = 0,
        property = (gsap.getProperty("html", "--header-height") + gsap.getProperty("html", "--header-offset")) + 'px';

      section.tl = gsap.timeline({
        scrollTrigger: {
          trigger: section,
          start: "top center"
        }
      });

      document.fonts.ready.then(function () {
        section.splittext = new SplitText(section.querySelectorAll('.featured-product-card--heading, p:not(.subheading)'), {
          type: 'lines, words',
          linesClass: 'line-child'
        });

        if (section.querySelector('.subheading')) {
          section.tl
            .fromTo(section.querySelector('.subheading'), {
              opacity: 0
            }, {
              duration: 0.75,
              opacity: 0.6
            }, 0);

          button_offset += 0.5;
        }
        
        if (section.querySelector('.featured-product-card--heading')) {
          let h3_duration = 0.8 + ((section.querySelectorAll('.featured-product-card--heading .line-child div').length - 1) * 0.08);
          section.tl
            .set(section.querySelector('.featured-product-card--heading'), {
              visibility: 'visible'
            }, 0)
            .from(section.querySelectorAll('.featured-product-card--heading .line-child div'), {
              duration: h3_duration,
              yPercent: '100',
              stagger: 0.08
            }, 0);
          button_offset += h3_duration;
        }
        
        if (section.querySelector('.rte p')) {
          let p_duration = 0.8 + ((section.querySelectorAll('.rte p .line-child div').length - 1) * 0.02);
          section.tl
            .set(section.querySelectorAll('.rte p'), {
              visibility: 'visible'
            }, 0)
            .from(section.querySelectorAll('.rte p .line-child div'), {
              duration: p_duration,
              yPercent: '100',
              stagger: 0.02
            }, 0);
          button_offset += p_duration;
        }
        
        if (section.querySelectorAll('.button')) {
          let i = 1;
          section.querySelectorAll('.button').forEach((item) => {
            section.tl.fromTo(item, {
              autoAlpha: 0
            }, {
              duration: 0.5,
              autoAlpha: 1
            }, ((button_offset * 0.4) + (i - 1) * 0.1));
            i++;
          });
        }
      });

      if (section.querySelector('.thb-parallax-image')) {
        gsap.fromTo(section.querySelectorAll('.thb-parallax-image'), {
          y: '-8%'
        }, {
          y: '8%',
          ease: 'none',
          scrollTrigger: {
            trigger: section,
            scrub: 1,
            start: () => `top bottom`,
            end: () => `bottom top+=${property}`,
            onUpdate: () => {
              property = (gsap.getProperty("html", "--header-height") + gsap.getProperty("html", "--header-offset")) + 'px';
            }
          }
        });
      }
    }
  }
  customElements.define('featured-product-card', FeaturedProductCard);
}
// document.addEventListener('DOMContentLoaded', function() {
//   const sections = document.querySelectorAll('.section-featured-product-card');

//   sections.forEach(section => {
//     const carousel = section.querySelector('.featured-product-carousel');
//     if (!carousel || typeof Splide === 'undefined') return;

//     const splide = new Splide(carousel, {
//       type: 'slide',
//       rewind: true,
//       pagination: false,
//       arrows: true,
//       drag: false, // only arrow nav
//       keyboard: false,
//       autoplay: section?.dataset.autoplay === 'true',
//       interval: parseInt(section?.dataset.autoplayInterval) || 5000,
//       pauseOnHover: section?.dataset.pauseOnHover !== 'false',
//       pauseOnFocus: true,
//       speed: 800,
//       easing: 'cubic-bezier(0.25, 0.46, 0.45, 0.94)',
//     });

//     // ✅ Progress bar inside this section only
//     const desktopProgressBar = section.querySelector('.desktop-progress .splide__progress__bar');
//     const mobileProgressBar = section.querySelector('.mobile-progress .splide__progress__bar');

//     const updateProgress = (index) => {
//       const totalSlides = splide.length; 
//       const progress = ((index + 1) / totalSlides) * 100; 
//       if (desktopProgressBar) desktopProgressBar.style.width = `${progress}%`;
//       if (mobileProgressBar) mobileProgressBar.style.width = `${progress}%`;
//     };

// // ✅ Attach listeners only to THIS outer splide
// splide.on('mounted', () => updateProgress(splide.index));
// splide.on('move', () => updateProgress(splide.index));


//     // ✅ Only bind to OUTER Splide events
//     splide.on('mounted move', () => {
//       updateProgress(splide.index);
//     });

//     splide.mount();
//   });
// });


window.addEventListener('beforeunload', function() {
  const carousels = document.querySelectorAll('.featured-product-carousel');
  carousels.forEach(carousel => {
    if (carousel.splideInstance) {
      carousel.splideInstance.destroy();
    }
  });
});